import axios from "axios";
import { PRODUCTS as STATIC_PRODUCTS } from "@/data/products";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const getToken = () => localStorage.getItem("gn_admin_token") || "";
export const setToken = (t) => {
  if (t) localStorage.setItem("gn_admin_token", t);
  else localStorage.removeItem("gn_admin_token");
};
export const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const imgUrl = (src) => (src && src.startsWith("/api") ? `${BACKEND}${src}` : src);

let cache = null;
export async function fetchProducts(force = false) {
  if (cache && !force) return cache;
  try {
    const { data } = await axios.get(`${API}/products`);
    if (Array.isArray(data) && data.length) {
      cache = data;
      return data;
    }
  } catch (e) {
    // fall back to bundled static catalogue
  }
  cache = STATIC_PRODUCTS;
  return cache;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
